// src/components/accueil/disponibiliteCartes.ts — SCE Issues
// Les cartes de l'accueil qu'une personne a le droit de voir (chantier du 03/11) :
// la disposition n'en place pas d'autres, le catalogue n'en propose pas d'autres,
// et une carte retirée faute de droit n'est pas comptée comme « masquée ».
// Mêmes gardes que les cartes elles-mêmes (CarteRevueFnct, CarteActionsFnct).

import { FNCT_MASQUEE } from '@/config/fnct.config'
import { accesFnct, meneLaRevueFnct } from '@/utils/droitsFnct'
import { ORDRE_FILES } from '@/utils/accueil'
import { fileDeCarte, type RoleAccueil } from '@/utils/dispositionAccueil'

// Les cartes de chaque accueil (lot 8) : celles du coordinateur n'existent pas
// sur l'accueil opérateur, et inversement.
const CARTES_PILOTE = new Set(['file', 'activite', 'revueFnct', 'actionsFnct', 'suivis'])
const CARTES_OPERATEUR = new Set(['declarer', 'revueFnct', 'actionsFnct', 'nouveautes', 'suivis', 'mesDeclarations', 'derniers', 'activite'])

/** La carte existe-t-elle sur l'accueil de ce rôle ? (sans les droits de la personne : /admin) */
export function carteDuRole(id: string, role: RoleAccueil): boolean {
  // Une file en carte (`file:critiques`) : une file qui existe, sur l'accueil d'un pilote.
  const f = fileDeCarte(id)
  if (f !== null) return role !== 'operateur' && (ORDRE_FILES as readonly string[]).includes(f)
  return (role === 'operateur' ? CARTES_OPERATEUR : CARTES_PILOTE).has(id)
}

export function carteDisponible(id: string, upn: string, fournisseur: boolean, role: RoleAccueil = 'coordinateur'): boolean {
  if (!carteDuRole(id, role)) return false
  if (fileDeCarte(id) !== null) return true
  switch (id) {
    case 'revueFnct':
      return !fournisseur && !FNCT_MASQUEE && accesFnct(upn) && meneLaRevueFnct(upn)
    case 'actionsFnct':
      return !fournisseur && !FNCT_MASQUEE && accesFnct(upn)
    default:
      return true
  }
}
